import { render, staticRenderFns } from "./InternalTests.vue?vue&type=template&id=3d4c385d&scoped=true&"
import script from "./InternalTests.vue?vue&type=script&lang=js&"
export * from "./InternalTests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4c385d",
  null
  
)

export default component.exports